import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropertyListings from '../PropertyListings';
import RentalHistory from '../actions/RentalHistory/RentalHistory';
import { ProfileType } from '../../utils/profileType';
import { setLastMobileTab } from '../../utils/mobileApp';

type OwnerActions = {
  openCreateContract: () => void;
  openCreateList: () => void;
  openListActions: () => void;
};

const MobileManagePanel: React.FC<{ profileType: ProfileType }> = ({ profileType }) => {
  const [showHistory, setShowHistory] = useState(false);
  const navigate = useNavigate();
  const ownerActionsRef = useRef<OwnerActions | null>(null);

  useEffect(() => {
    setLastMobileTab('manage');
  }, []);

  const actionClass = (active = false) =>
    `shrink-0 rounded-full px-3 py-2 text-xs font-semibold ${
      active ? 'bg-[#C4A35A] text-white shadow-sm' : 'border border-black/10 bg-white text-black/70'
    }`;

  return (
    <section className="space-y-3">
      <div className="flex gap-1.5 overflow-x-auto pb-0.5">
        <button
          type="button"
          onClick={() => {
            setShowHistory(false);
            navigate('/add-product');
          }}
          className="shrink-0 rounded-full bg-[#C4A35A] px-3 py-2 text-xs font-semibold text-white"
        >
          <i className="fas fa-plus mr-1.5" />
          Thêm phòng
        </button>
        <button
          type="button"
          onClick={() => {
            setShowHistory(false);
            ownerActionsRef.current?.openCreateContract();
          }}
          className={actionClass()}
        >
          <i className="fas fa-file-contract mr-1.5" />
          Tạo hợp đồng
        </button>
        <button
          type="button"
          onClick={() => {
            setShowHistory(false);
            ownerActionsRef.current?.openListActions();
          }}
          className={actionClass()}
        >
          <i className="fas fa-layer-group mr-1.5" />
          Tạo/ Xóa danh sách
        </button>
        <button
          type="button"
          onClick={() => setShowHistory(true)}
          className={actionClass(showHistory)}
        >
          <i className="fas fa-history mr-1.5" />
          Lịch sử
        </button>
      </div>

      <div className={showHistory ? 'hidden' : 'overflow-visible rounded-2xl border border-black/5 bg-white'}>
        <PropertyListings
          accountType={profileType}
          hideOwnerToolbar
          compactNative
          ownerActionsRef={ownerActionsRef}
        />
      </div>

      {showHistory && (
        <div className="rounded-2xl border border-black/5 bg-white p-3">
          <RentalHistory profileType={profileType} />
        </div>
      )}
    </section>
  );
};

export default MobileManagePanel;
